import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Section } from '../styles/CommonElements';
import Newsletter from '../components/Newsletter';
import SEO from '../components/SEO';

// Styled components for the blog page
const BlogHero = styled.div`
  padding: 5rem 0 3rem;
  position: relative;
  background-color: #f9f9f9;
  margin-top: -1rem;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: var(--primary-color);
  }
`;

const BlogContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
  
  @media (max-width: 768px) {
    padding: 0 1.5rem;
  }
`;

const BlogTitle = styled.h1`
  font-size: 2.8rem;
  font-weight: 800;
  color: #2a3b4c;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
`;

const BlogContent = styled(Section)`
  background-color: white;
  padding: 4rem 0;
  
  @media (max-width: 768px) {
    padding: 3rem 0;
  }
  
  @media (max-width: 480px) {
    padding: 2rem 0;
  }
`;

const ComingSoonContainer = styled.div`
  text-align: center;
  padding: 5rem 0;
`;

const ComingSoonTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: #2a3b4c;
  margin-bottom: 1.5rem;
`;

const ComingSoonMessage = styled.p`
  font-size: 1.2rem;
  color: #546677;
  max-width: 600px;
  margin: 0 auto 2rem;
`;

const BackToBlogs = styled(Link)`
  display: inline-flex;
  align-items: center;
  color: #444;
  font-weight: 600;
  text-decoration: none;
  margin-top: 3rem;
  transition: color 0.2s ease;
  
  &:hover {
    color: var(--primary-color);
  }
  
  &::before {
    content: '←';
    margin-right: 8px;
    transition: transform 0.2s ease;
  }
  
  &:hover::before {
    transform: translateX(-3px);
  }
`;

const BlogPage: React.FC = () => {
  return (
    <main>
      <SEO 
        title="Blog Article | Uptrend Systems Blog"
        description="Uptrend Systems Blog - Articles coming soon."
        keywords="software development, technology insights, business solutions"
        canonicalUrl="/blog"
        pageType="article"
      />
      
      <BlogHero>
        <BlogContainer className="font--jakarta">
          <BlogTitle>Blog Articles</BlogTitle>
        </BlogContainer>
      </BlogHero>
      
      <BlogContent>
        <BlogContainer>
          <ComingSoonContainer>
            <ComingSoonTitle>Coming Soon</ComingSoonTitle>
            <ComingSoonMessage>
              Our blog articles are currently being developed. Check back soon for expert insights on software development, technology trends, and business solutions.
            </ComingSoonMessage>
            <BackToBlogs to="/blog">Back to blog</BackToBlogs>
          </ComingSoonContainer>
        </BlogContainer>
      </BlogContent>
      
      <Newsletter />
    </main>
  );
};

export default BlogPage; 